import clsx from 'clsx';
import Style from './toggleButton.module.scss';
import { ReactNode, useState } from 'react';

export type SettingsToggleButtonItem<T> = {
  value: T;
  icon: ReactNode;
};

export type SettingsToggleButtonProps<T> = {
  menuItems: SettingsToggleButtonItem<T>[];
  defaultValue?: T;
  onSelect?: (value: T) => void;
};

export const SettingsToggleButton = <T extends NonNullable<unknown>>({
  menuItems,
  defaultValue,
  onSelect,
}: SettingsToggleButtonProps<T>) => {
  const [value, setValue] = useState<T | undefined>(defaultValue);
  const handleAlignment = (newValue: T) => () => {
    if (newValue !== null) {
      setValue(newValue as T);
      onSelect?.(newValue);
    }
  };

  return (
    <div className={Style.container}>
      {menuItems.map((item, i) => (
        <button
          key={i}
          className={clsx(Style.button, { [Style.selected]: item.value === value })}
          onClick={handleAlignment(item.value)}
        >
          {item.icon}
        </button>
      ))}
    </div>
  );
};
